<template>
    <div class="Talk" :class="{ hide: !grimoire.isTalk }" v-if="!session.isSpectator || GetClaimedSeat">
        <div class="talkHeader">
            <font-awesome-icon
                class="Talk-icon"
                icon="arrow-circle-left"
                v-show="SessionId != 0"
                @click.stop="SessionId = 0"
            />
            <div class="Talk-title">
                私聊
                <template v-if="grimoire.isTalk">
                    ——下载游民星空APP修改头像及昵称
                </template>
            </div>
            <font-awesome-icon
                class="Talk-icon"
                icon="times-circle"
                v-show="grimoire.isTalk"
                @click.stop="$store.commit('toggleTalk')"
            />
            <font-awesome-icon
                class="Talk-icon"
                icon="plus-circle"
                v-show="!grimoire.isTalk"
                @click.stop="$store.commit('toggleTalk')"
            />
        </div>
        <div class="NewMessage" v-if="newMessage"></div>
        <!-- 会话列表 -->
        <div class="UserSessions" v-show="SessionId == 0">
            <!--  v-if="session.isSpectator" -->
            <a href="javascript:;" class="modifyUserName" @click="modifyUserName()">修改昵称</a>
            <!-- <a href="javascript:;" style="font-size:14px;" @click="GetUserSessions()">更新列表</a> -->
            <div
                class="UserSession"
                :class="{ cur: SessionId == session.sessionId }"
                v-for="session in UserSessions"
                :key="session.sessionId"
                @click="
                    (SessionId = session.sessionId),
                        (AnotherGSUserId = session.anotherGSUserId),
                        (CacheKey = session.cacheKey)
                "
            >
                <img :src="session.anotherUserHeadImageUrl" />
                <p>{{ session.seatNumber }}{{ session.seatName }}</p>
                <!-- {{ session.anotherUserName }} -->
                <i class="unreadsCount" v-if="session.unreadsCount > 0"></i>
            </div>
        </div>
        <!-- 聊天列表 -->
        <div class="SessionMessage" v-show="SessionId != 0">
            <div class="MessageList" ref="MessageList">
                <div
                    class="Message-Item"
                    :class="{ selfMessage: userInfo.userid == message.senderGSUserId }"
                    :dir="userInfo.userid == message.senderGSUserId ? 'rtl' : 'ltr'"
                    v-for="message in NewestMessages"
                    :key="message.id"
                >
                    <img class="headImage" :src="message.senderUserHeadImageUrl" />
                    <div class="content">
                        <p class="name">{{ message.senderUserName }}</p>
                        <div class="massage" :dir="userInfo.userid == message.senderGSUserId ? 'ltr' : ''">
                            {{ message.content }}
                        </div>
                    </div>
                </div>
            </div>
            <div class="MessageInput">
                <input
                    type="text"
                    @focus="$store.commit('toggleFocus')"
                    @blur="$store.commit('toggleFocus')"
                    v-model="MessageContent"
                    @keyup.enter="SendMessage()"
                />
                <a href="javascript:;" @click="SendMessage()">发送</a>
            </div>
        </div>
    </div>
</template>
<script>
import qs from "qs";
import Bus from "../bus";
import { mapGetters, mapState } from "vuex";
export default {
    name: "Talk",
    data() {
        return {
            userInfo: this.$utils.cookie("UserCookie") ? JSON.parse(this.$utils.cookie("UserCookie")) : {},
            toggleTalks: false,
            MessageContent: "",
            SessionId: 0,
            AnotherGSUserId: 0,
            CacheKey: "",
            PrevMessageCreateTime: "",
            UserSessions: [],
            UserSessionsTimer: null,
            NewestMessages: [],
            NewestMessageTimer: null
        };
    },
    mounted() {
        Bus.$on("openHomeowner", target => {
            if (target) {
                this.UserSessions.forEach(session => {
                    if (session.anotherGSUserId == this.session.sessionUserInfo.userid) {
                        this.SessionId = session.sessionId;
                        this.AnotherGSUserId = session.anotherGSUserId;
                        this.CacheKey = session.cacheKey;
                        if (!this.grimoire.isTalk) {
                            this.$store.commit("toggleTalk");
                        }
                    }
                });
            }
        });
        Bus.$on("openGroupChat", target => {
            if (target) {
                this.UserSessions.forEach(session => {
                    if (session.cacheKey.indexOf("businessKey=" + this.session.sessionId) != -1) {
                        this.SessionId = session.sessionId;
                        this.AnotherGSUserId = session.anotherGSUserId;
                        this.CacheKey = session.cacheKey;
                        if (!this.grimoire.isTalk) {
                            this.$store.commit("toggleTalk");
                        }
                    } else {
                        this.$toast("您还没有群聊");
                    }
                });
            }
        });

        Bus.$on("createSession", target => {
            this.RemoveSession();
        });
        this.UserSessionsTimer = window.setInterval(() => {
            this.GetUserSessions();
            this.GetSessionNewestMessages();
        }, 750);
    },
    computed: {
        newMessage() {
            let messageTips = false;
            this.UserSessions.map(item => {
                if (item.unreadsCount > 0) {
                    messageTips = true;
                }
            });
            return messageTips;
        },

        ...mapGetters({ GetClaimedSeat: "session/GetClaimedSeat" }),
        ...mapState(["grimoire", "session"]),
        ...mapState(["players", ["players", "bluffs", "fabled"]])
    },
    methods: {
        // 获取所有用户会话列表
        GetUserSessions() {
            this.$ajax
                .get(this.$ajax.url + "/Sessions/GetUserSessions", {
                    IsGetUnfollowSessions: true
                })
                .then(response => {
                    if (response.error == "") {
                        if (response.sessions && response.sessions.length > 0) {
                            if (!this.session.isSpectator) {
                                this.UserSessions = response.sessions.filter(item => {
                                    if (item.cacheKey.indexOf("businessKey=" + this.session.sessionId) != -1) {
                                        if (!this.grimoire.isGroupChat) {
                                            this.$store.commit("toggleGroupChat");
                                        }
                                        return item;
                                    }
                                    for (let i = 0; i < this.players.players.length; i++) {
                                        if (
                                            this.players.players[i].userInfo &&
                                            this.players.players[i].userInfo.userid == item.anotherGSUserId
                                        ) {
                                            if (this.session.sessionUserInfo.userid != item.anotherGSUserId) {
                                                item["seatNumber"] = i + 1 + "号-";
                                                item["seatName"] = this.players.players[i].name;
                                            } else {
                                                item["seatNumber"] = "说书人";
                                                item["seatName"] = "";
                                            }
                                            return item;
                                        }
                                    }
                                });
                            } else {
                                this.UserSessions = response.sessions.filter(item => {
                                    if (item.cacheKey.indexOf("businessKey=" + this.session.sessionId) != -1) {
                                        if (!this.grimoire.isGroupChat) {
                                            this.$store.commit("toggleGroupChat");
                                        }
                                        return item;
                                    }
                                    for (let i = 0; i < this.players.players.length; i++) {
                                        if (
                                            (this.players.players[i].userInfo &&
                                                this.players.players[i].userInfo.userid == item.anotherGSUserId) ||
                                            (this.session.sessionUserInfo &&
                                                this.session.sessionUserInfo.userid == item.anotherGSUserId)
                                        ) {
                                            if (this.session.sessionUserInfo.userid != item.anotherGSUserId) {
                                                item["seatNumber"] = i + 1 + "号-";
                                                item["seatName"] = this.players.players[i].name;
                                            } else {
                                                item["seatNumber"] = "说书人";
                                                item["seatName"] = "";
                                            }
                                            return item;
                                        }
                                    }
                                    // if (
                                    //     this.session.sessionUserInfo &&
                                    //     this.session.sessionUserInfo.userid == item.anotherGSUserId
                                    // ) {
                                    //     return item;
                                    // }
                                });
                            }
                        }
                    }
                });
        },
        // 获取最新消息
        GetSessionNewestMessages() {
            if (this.SessionId == 0) return;
            this.$ajax
                .get(this.$ajax.url + "/Messages/GetSessionNewestMessages", {
                    SessionId: this.SessionId,
                    PrevMessageCreateTime: this.PrevMessageCreateTime
                })
                .then(response => {
                    if (response.error == "") {
                        let isScroll = false;
                        if (response.messages.length != this.NewestMessages.length) {
                            isScroll = true;
                        }
                        this.NewestMessages = response.messages;
                        if (response.messages.length > 0) {
                            this.PrevMessageCreateTime =
                                response.messages[response.messages.length - 1].createTime || "";
                        }
                        this.$nextTick(() => {
                            if (isScroll) {
                                this.$refs.MessageList.scrollTop = this.$refs.MessageList.scrollHeight;
                            }
                        });

                        this.ReadSessionMessages();
                    }
                });
        },
        // 已读消息
        ReadSessionMessages() {
            this.$ajax
                .get(this.$ajax.url + "/Messages/ReadSessionMessages", {
                    SessionId: this.SessionId
                })
                .then(response => {
                    if (response.error == "") {
                        // this.NewestMessages = response.messages;
                    }
                });
        },
        // 发送消息
        SendMessage(userId = this.AnotherGSUserId, MessageContent = this.MessageContent) {
            let SendUserId =
                this.CacheKey.indexOf("businessKey=" + this.session.sessionId) != -1
                    ? this.session.sessionUserInfo.userid
                    : userId;
            let SendSessionId =
                this.CacheKey.indexOf("businessKey=" + this.session.sessionId) != -1 ? this.SessionId : 0;
            if (
                SendUserId == 0 ||
                SendUserId == JSON.parse(decodeURIComponent(this.$utils.cookie("UserCookie"))).userid
            )
                return;
            this.$ajax
                .post(this.$ajax.url + "/Messages/SendMessage", {
                    SessionId: SendSessionId,
                    AnotherGSUserId: SendUserId,
                    MessageContent: MessageContent
                })
                .then(response => {
                    if (response.error == "" || response.error == null) {
                        this.MessageContent = "";
                        if (!this.session.isSpectator) {
                            this.$utils
                                .AjaxJsonp("//click.gamersky.com/Common/GetHits.aspx", {
                                    id: 1479707,
                                    script: 3
                                })
                                .then(response => {});
                        }
                    }
                });
        },
        // 创建群聊
        CreateSession() {
            let AnotherSessionUserIds = [];
            this.players.players.forEach(item => {
                if (item.userInfo && item.role && (item.role.team == "minion" || item.role.team == "demon")) {
                    AnotherSessionUserIds.push(item.userInfo.userid);
                }
            });
            if (AnotherSessionUserIds.length > 0) {
                this.$ajax
                    .post(this.$ajax.url + "/Sessions/CreateSession", {
                        BusinessKey: String(this.session.sessionId),
                        SessionTitle: this.session.sessionUserInfo.username + "的狼群聊",
                        SessionIconImageUrl: this.session.sessionUserInfo.username + "的狼群聊",
                        AnotherSessionUserIds: AnotherSessionUserIds
                    })
                    .then(response => {});
            }
        },
        // 删除群聊
        RemoveSession() {
            let UserSession = this.UserSessions.filter(item => {
                if (item.cacheKey.indexOf("businessKey=" + this.session.sessionId) != -1) {
                    return item;
                }
            });
            if (UserSession.length > 0) {
                this.$ajax
                    .post(this.$ajax.url + "/Sessions/RemoveSession", {
                        SessionId: UserSession[0].sessionId
                    })
                    .then(response => {
                        if (response.error == "") {
                            this.CreateSession();
                        }
                    });
            } else {
                this.CreateSession();
            }
        },
        // 修改昵称
        modifyUserName() {
            this.$alert({
                title: "修改昵称",
                value: JSON.parse(decodeURIComponent(this.$utils.cookie("UserCookie"))).username
            }).then(name => {
                if (name) {
                    this.$ajax
                        .post(
                            "//i.gamersky.com/user/info/edit",
                            qs.stringify({
                                newNickName: name
                            })
                        )
                        .then(response => {
                            if (response.StatusCode == 0) {
                                this.$toast("修改成功,即将刷新页面");
                                this.$utils.logincheck().then(response => {
                                    this.$store.commit("session/claimSeat", -1);
                                    setTimeout(() => {
                                        window.location.reload(true);
                                    }, 2000);
                                });
                            } else {
                                if (response.StatusCode == 4) {
                                    this.$toast("二次修改昵称需登录游民星空app进行修改");
                                } else if (response.StatusCode == -2) {
                                    let phonenumber =
                                        JSON.parse(decodeURIComponent(this.$utils.cookie("UserCookie"))).phonenumber ||
                                        null;
                                    if (phonenumber) {
                                        this.GetVerificationCode();
                                        this.$alert({
                                            title: "添加密码(自动随机密码)",
                                            text: "已向您绑定的手机发送验证码，请填写手机验证码修改密码",
                                            close: true
                                        }).then(code => {
                                            if (code) {
                                                this.ModifyPassword(phonenumber, code);
                                            }
                                        });
                                    } else {
                                        this.$toast("未找到绑定手机号，修改失败");
                                    }
                                } else {
                                    this.$toast(response.Message);
                                }
                            }
                            console.log(response);
                        });
                    // this.$store.commit("players/add", name);
                }
            });
        },
        // 获取验证码
        GetVerificationCode(phonenumber) {
            let data = {
                deviceType: "iPhone13,2",
                deviceId: "9B9F7688-CB21-4692-B70B-C86AA77A9BBA",
                os: "iOS",
                osVersion: "15.2",
                app: "GSApp(iOS)",
                appVersion: "6.0.9",
                request: {
                    codetype: 1,
                    phoneNumber: phonenumber,
                    email: "",
                    username: ""
                }
            };
            this.$ajax.post("//appapi2.gamersky.com/v2/GetVerificationCode1", JSON.stringify(data)).then(response => {
                if (response.errorCode != 0) {
                    this.$toast(response.errorMessage);
                }
            });
        },
        // 修改密码
        ModifyPassword(phonenumber, verifyToken) {
            let data = {
                deviceType: "x86_64",
                deviceId: "A6D2DD48-E3A8-4E1D-A9E3-40A4096B8FAC",
                os: "iOS",
                osVersion: "11.2",
                app: "GSApp",
                appVersion: "3.7.1",
                request: {
                    phoneNumber: phonenumber,
                    verifyToken: verifyToken,
                    newPassword: Math.random()
                        .toString(36)
                        .slice(-10)
                }
            };
            this.$ajax.post("//appapi2.gamersky.com/v2/ModifyPassword", JSON.stringify(data)).then(response => {
                if (response.errorCode != 0) {
                    this.$toast(response.errorMessage);
                } else {
                    this.$toast("添加密码成功，请继续修改昵称");
                    window.alertClose.destroyVm();
                    window.alertClose = null;
                }
            });
        }
    },
    watch: {
        grimoire: {
            handler(val) {
                let isTalk = val.isTalk;
                if (!isTalk) {
                    this.SessionId = 0;
                    this.AnotherGSUserId = 0;
                    this.NewestMessages = [];
                }
            },
            deep: true
        },
        // toggleTalks(val) {
        //     if (!val) {
        //         this.SessionId = 0;
        //         this.AnotherGSUserId = 0;
        //         this.NewestMessages = [];
        //     }
        // },
        GetClaimedSeat(isClaimedSeat) {
            if (isClaimedSeat) {
                this.SendMessage(this.session.sessionUserInfo.userid, `${this.session.playerUserInfo.username}已入座`);
            }
        }
        // NewestMessages() {
        //     this.$nextTick(() => {
        //         if (this.NewestMessages != val) {
        //             this.$refs.MessageList.scrollTop = this.$refs.MessageList.scrollHeight;
        //         }
        //     });
        // }
    },
    beforeDestroy() {
        window.clearInterval(this.UserSessionsTimer);
        this.UserSessionsTimer = null;
    }
};
</script>
<style lang="scss" scoped>
.Talk {
    display: flex;
    flex-direction: column;
    position: absolute;
    right: 10px;
    bottom: 10px;
    background: rgba(0, 0, 0, 0.5);
    border-radius: 10px;
    border: 3px solid black;
    filter: drop-shadow(0 4px 6px rgba(0, 0, 0, 0.5));
    transform-origin: bottom left;
    transform: scale(1);
    opacity: 1;
    transition: all 200ms ease-in-out;
    z-index: 80;
    height: 350px;
    width: 500px;
    padding: 15px;
    padding-top: 30px;
    box-sizing: border-box;
    .UserSessions {
        width: 100%;
        height: 100%;
        overflow-y: auto;
        overflow-x: hidden;
        margin-right: 15px;
        background: rgba(255, 255, 255, 0.2);
        padding: 0 10px;
        box-sizing: border-box;
        border-radius: 4px;
        &::-webkit-scrollbar {
            display: none;
        }
        .modifyUserName {
            font-size: 14px;
            color: #ffffff;
            &:hover {
                color: red;
            }
        }
        .UserSession {
            display: flex;
            align-items: center;
            justify-content: flex-start;
            position: relative;
            padding: 10px 0;
            width: 100%;
            height: auto;
            cursor: pointer;
            box-sizing: border-box;
            transition: all 0.2s;
            border-bottom: 1px solid #eee;
            &:last-of-type {
                border: 0;
            }
            img {
                display: block;
                width: 25px;
                height: 25px;
                border-radius: 50%;
                transition: all 0.2s;
                box-sizing: border-box;
            }
            &.cur {
                img {
                    border: 2px solid #67c23a;
                }
                p {
                    color: #67c23a;
                }
            }
            p {
                margin: 0;
                font-size: 12px;
                font-family: "宋体";
                display: -webkit-box;
                -webkit-box-orient: vertical;
                -webkit-line-clamp: 2;
                overflow: hidden;
                padding-left: 10px;
                box-sizing: border-box;
            }
            &:hover {
                p {
                    color: red;
                }
            }
            .unreadsCount {
                position: absolute;
                left: 0;
                top: 8px;
                background: red;
                color: #ffffff;
                font-size: 12px;
                border-radius: 50%;
                width: 8px;
                height: 8px;
            }
        }
    }
    .SessionMessage {
        display: flex;
        flex-direction: column;
        align-items: center;
        height: 100%;
        flex: 1;
        border: 2px solid #fff;
        border-radius: 10px;
        background: rgba(255, 255, 255, 0.4);
        overflow: hidden;
        .MessageList {
            flex: 1;
            width: 100%;
            padding: 10px;
            overflow-y: auto;
            overflow-x: hidden;
            .Message-Item {
                display: flex;
                margin-bottom: 10px;
                .headImage {
                    flex-shrink: 0;
                    display: block;
                    width: 35px;
                    height: 35px;
                    margin-right: 8px;
                    border-radius: 50%;
                    overflow: hidden;
                }
                .content {
                    .name {
                        margin: 0;
                        font-size: 12px;
                        color: #ccc;
                    }
                    .massage {
                        position: relative;
                        font-size: 12px;
                        padding: 5px;
                        background: #ffffff;
                        color: #222;
                        border-radius: 4px;
                        &::before {
                            content: " ";
                            border: 5px solid transparent;
                            width: 0;
                            height: 0;
                            border-right-color: #ffffff;
                            position: absolute;
                            margin-right: 0;
                            right: 100%;
                            top: 10px;
                        }
                    }
                }
                &.selfMessage {
                    .headImage {
                        margin-right: 0;
                        margin-left: 8px;
                    }
                    .content {
                        .massage {
                            background: #67c23a;
                            &::before {
                                content: " ";
                                border: 5px solid transparent;
                                width: 0;
                                height: 0;
                                border-left-color: #67c23a;
                                position: absolute;
                                margin-right: 0;
                                right: -10px;
                                top: 10px;
                            }
                        }
                    }
                }
            }
        }
        .MessageInput {
            display: flex;
            align-items: center;
            padding: 0 10px;
            width: 100%;
            height: 40px;
            border-top: 2px solid #ffffff;
            box-sizing: border-box;
            flex-shrink: 0;
            input {
                display: block;
                flex: 1;
                height: 30px;
                border: 0;
                border-radius: 5px;
                outline: none;
                padding: 0 15px;
                box-sizing: border-box;
            }
            a {
                display: flex;
                justify-content: center;
                align-items: center;
                width: 60px;
                height: 30px;
                margin-left: 10px;
                font-size: 14px;
                background: #1f65ff;
                color: #fff;
                text-decoration: none;
                border-radius: 5px;
                overflow: hidden;
            }
        }
    }
    .talkHeader {
        position: absolute;
        left: 50%;
        top: 0;
        transform: translateX(-50%);
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 100%;
        height: 30px;
        padding: 0 15px;
        .Talk-title {
            font-size: 14px;
        }
        .Talk-icon {
            cursor: pointer;
            z-index: 5;
            &:hover {
                color: red;
                path {
                    fill: url(#demon);
                    stroke-width: 30px;
                    stroke: white;
                }
            }
        }
    }

    .NewMessage {
        display: block;
        position: absolute;
        top: 3px;
        left: 5px;
        width: 10px;
        height: 10px;
        background: red;
        border-radius: 50%;
    }
    &.hide {
        height: 30px;
        padding-top: 15px;
        .UserSessions {
            width: 0;
            height: 0;
            transition: all 0.1s;
            overflow: hidden;
            opacity: 0;
        }
        .SessionMessage {
            width: 0;
            height: 0;
            transition: all 0.1s;
            overflow: hidden;
            opacity: 0;
        }
    }
}
@media screen and (max-width: 500px) {
    .Talk {
        flex-direction: column;
        width: 100%;
        height: 60vh;
        right: 0;
        bottom: 0;
        .UserSessions {
            flex: 1;
            height: 0;
            width: 100%;
            overflow-x: hidden;
            overflow-y: auto;
            -webkit-overflow-scrolling: touch;
            .UserSession {
                flex-shrink: 0;
                margin-bottom: 0;
                margin-right: 10px;
                max-height: 35px;
                img {
                    width: 30px;
                    height: 30px;
                }
            }
        }
        .SessionMessage {
            flex: 1;
            width: 100%;
        }
        svg {
            font-size: 23px;
        }
        &.hide {
            right: unset;
            left: 10px;
            bottom: 90px;
            width: 50vw;
            padding: 0;
            height: 36px;
            .Talk-title {
                font-size: 12px;
            }
            svg {
                top: 1px;
            }
        }
    }
}
</style>
